<template>
  <div class="widget-height">
    <div class="header">
      <div class="title">
        <img src="/static/images/icons/calender_icon.svg" class="calender_icon" />
        <span>Upcoming Events</span>
      </div>
    </div>
    <div class="content" :class="{ 'fix-height': isCombo, 'single-height': !isCombo }">
      <div v-if="upcomingRegistrations.length > 0">
        <div
          class="upcoming-regns"
          v-for="(registration, index) in upcomingRegistrations"
          v-bind:key="index"
        >
          <div class="row col-xs-12 notification-date-css" :class="isCombo ? 'pt-8' : ''">
            {{ registration.date | UTCDate('MMM DD, YYYY') }}
          </div>
          <div
            class="row"
            v-for="registrationIds in registration.registrations"
            :key="registrationIds"
          >
            <div class="col-xs-12 reg-pd">
              <img class="alert-triangle" src="/static/images/icons/alert_triangle.svg" />
              <span class="reg-expr">Registration expires</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-27" v-if="upcomingRegistrations.length === 0">
        <span class="no-events">No upcoming events</span>
      </div>
    </div>
    <registration-details-popup
      v-if="dashboardRecordsFlag"
      :permissions="permissions"
      :dashboardRecordsFlag="dashboardRecordsFlag"
      :dataRow="activeRegistration"
      :reportFlag="true"
      @dashboardWidgets="dashboardWidgets"
    ></registration-details-popup>
    <permission-access-modal></permission-access-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import PermissionAccessModal from '../../../Common/PermissionAccessModal.vue';
import { getUpcomingRegistrations } from '../../../../apis/dashboard';
import { getRegistrationDetailsById } from '../../../../apis/registrations';
import constructRegistrationObject from '../../../../utils/registrationDetails';
import RegistrationDetailsPopup from '../../../Registrations/RegistrationDetailsPopup.vue';

export default {
  props: ['isCombo', 'permissions'],
  components: {
    PermissionAccessModal,
    RegistrationDetailsPopup
  },
  data() {
    return {
      dashboardRecordsFlag: false,
      upcomingRegistrations: [],
      loaderStatus: false,
      activeRegistration: {}
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    dashboardWidgets() {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = false;
    },
    async getUpcomingRegistrations() {
      this.upcomingRegistrations = [];
      const upcomingRegistrns = await getUpcomingRegistrations(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      upcomingRegistrns.splice(2);
      if (upcomingRegistrns.length > 0) {
        const registrrationDates = [];
        upcomingRegistrns.forEach((registration) => {
          if (registrrationDates.indexOf(registration.expiration_date) === -1) {
            registrrationDates.push(registration.expiration_date);
          }
        });
        this.upcomingRegistrations = registrrationDates.map((date) => {
          const registrationList = [];
          upcomingRegistrns.filter((registration) => {
            if (registration.expiration_date === date) {
              registrationList.push(registration.registration_id);
            }
            return true;
          });
          return { date, registrations: registrationList };
        });
      }
    },
    async viewRegistration(registrationId) {
      this.dashboardRecordsFlag = true;
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.loaderStatus = true;
        const selectedRegistration = await getRegistrationDetailsById(registrationId);
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification'
          });
        } else if (selectedRegistration) {
          this.activeRegistration = constructRegistrationObject(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    }
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    }
  },
  async created() {
    try {
      this.loaderStatus = true;
      await this.getUpcomingRegistrations();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
  }
};
</script>
<style scoped>
.widget-card {
  padding: 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
}
.header {
  border: 1px solid #ffffff;
  border-radius: 10px 10px 0px 0px;
}
.title {
  display: flex;
  align-items: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0b3c61;
  padding-left: 24px;
  padding-top: 24px;
}
.title span {
  padding-left: 19px;
}
.calender_icon {
  width: 32px;
  height: 32px;
}
.reg-pd {
  padding: 10px 1px 1px 32px;
}
.combo-widget-ht .widget-height {
  padding-bottom: 0px;
}
.content {
  min-height: 180px;
  padding: 0px 15px 0 10px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.no-events {
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding: 17px 15px;
}
.content-decoration {
  position: relative;
  padding: 0;
  border-top: 1px solid #174c76;
}
.headline-circle {
  position: absolute;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  padding: 0;
  right: 0;
  top: -3px;
}
.pt-27 {
  padding-top: 27px;
}
.ml-0 {
  margin-left: 0;
}
.pl-0 {
  padding-left: 0px;
}
.pr-0 {
  padding-right: 0px !important;
}
.month-data {
  font-weight: normal;
  font-size: 22px;
  line-height: 28px;
  color: #0b3c61;
}
.reg-expr {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 18px;
  cursor: pointer;
}
.alert-triangle {
  width: 22px;
  height: 22px;
}
.pt-10 {
  padding-top: 10px;
}
.url-hover a:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
.reg-expr-static {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-top: 5px;
  padding-bottom: 5px;
}
.notification-date-css {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
  padding-left: 32px;
}
.upcoming-regns:last-child .notification-date-css {
  padding-top: 20px;
}
.upcoming-regns .notification-date-css .pt-8 {
  padding-top: 8px;
}
.mt-10 {
  margin-top: 10px;
}
.word-wrap {
  word-wrap: break-word;
}
.fix-height {
  height: 230px;
}
.single-height {
  max-height: 190px;
}
@media only screen and (max-width: 767px) {
  .single-height {
    max-height: 240px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .month-data {
    font-size: 18px;
  }
  .reg-expr-static {
    font-size: 14px;
  }
}
@media (min-width: 1201px) and (max-width: 1400px) {
  .reg-expr-static {
    font-size: 14px !important;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .content-decoration {
    width: 100%;
  }
}
</style>
